import * as React from 'react';
import { useEffect } from 'react';
import { ErrorMessage, IconType } from 'ui-toolkit';
import { RotatingIcon } from '../../../../../../minipieces/documents/upload/RotatingIcon';
import { getRemittanceAction } from '../../../../../../store/order/escrow/remittenenceSlice';
import { initCdItems, loadItemsData } from '../../../../../../store/order/cdBuilder';
import { useSelector } from 'react-redux';
import { useKeyToSelect } from '../../../../../../store/createKeyedDataAsyncSlice';
import { useAppDispatch } from '../../../../../../store/store';
import { RootStore } from '../../../../../../store/types';
import { LoadingSection } from '../components/LoadingSection';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';
import { eTransactionCategory } from '../../../../../../ui-toolkit/enums/eTransactionType';

interface IInternalTransfersLoadingContainerProps {
  orderId: string;
  isSprucePowered: boolean;
}

export const InternalTransfersLoadingContainer: React.FC<IInternalTransfersLoadingContainerProps> = ({
  orderId,
  isSprucePowered,
}) => {
  const dispatch = useAppDispatch();
  const cdItems = useSelector((rootStore: RootStore) => rootStore.order.cdBuilder.cdItems);
  const { data: order } = useSelectCurrentOrder();
  const {
    data: remittance,
    fetchStatus,
    fetchError,
  } = useKeyToSelect(orderId, (store: RootStore) => store.order.escrow.remittanceSlice);
  useEffect(() => {
    dispatch(getRemittanceAction(orderId));
    dispatch(initCdItems(orderId, []));
    dispatch(
      loadItemsData(orderId, [], {
        ownerType: 'order',
        transactionType: eTransactionCategory.Refinance,
        loanAmount: 0,
        addressInfo: { state: '', street_address: '', city: '', zip_code: '' },
      })
    );
  }, [dispatch, orderId]);

  return fetchStatus.fetching ? (
    <RotatingIcon type={IconType.Loading} />
  ) : fetchError ? (
    <ErrorMessage
      error={fetchError instanceof Error ? fetchError : undefined}
      message={typeof fetchError === 'string' ? fetchError : fetchError.message}
    />
  ) : !fetchStatus.success ? (
    <ErrorMessage message="There was an error loading data..." />
  ) : !remittance ? (
    <ErrorMessage message="Underwriter Remittances are not loaded" />
  ) : cdItems && remittance.length ? (
    <LoadingSection
      orderId={orderId}
      parties={order.parties}
      cdItems={cdItems}
      remittances={remittance}
      isSprucePowered={isSprucePowered}
    />
  ) : null;
};
